jQuery(document).ready(function($) {
    setTimeout(function(){
        $(".top-bg-motion-bg-h").addClass("top-show-images")
    }, 2000);

    $(".providers-order").click(function() {
        $(this).toggleClass("providers-orders");

        if ($(this).hasClass('providers-orders')) {
            console.log("asd");
            $(this).text("ZA");
        } else {
            $(this).text("AZ");
        }
    });

    // $('.card-nubmer-mask').mask("0000-0000-0000-0000");
    // $('.card-nubmer-mask').mask("0000-0000-0000-0000", {placeholder: "0000-0000-0000-0000"});

    // $(".deposit-widthdraw-modal .select-deposits input[type=radio]").click(function() {
    //     $(".deposit-widthdraw-l .new-widthdraw-link").removeClass('gray-step-deposit');
    // });

    $(".deposit-widthdraw-l input").click(function() {
        $(".deposit-widthdraw-l").hide();
        $(".deposit-widthdraw-modal").addClass("deposit-widthdraw-modal-s");
        $(".deposit-widthdraw-r").show();
    });

    //open mobile footer links
    $(".footer-links-h h2").click(function() {
        $(this).parents(".footer-links-h").find('ul').slideToggle();
    });

    //slider HowTo block Jackpot
    $(".jackpot-terms__button").click(function() {
        const simpleBar = new SimpleBar(document.getElementById('slider'));
        simpleBar.recalculate();
        $(this).toggleClass('jackpot-terms__button--open');
        $(".jackpot-terms__content").toggleClass('jackpot-terms__content--open');
    });
});